import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { SearchPersonModal } from '../../../../../../components/Modal/SearchPersonModal'

export const FuncionariosListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: 'Localizar Funcionário',
      content: <SearchPersonModal />,
    })

  return (
    <Button className='btn-primary' onClick={openModal} icon={IconPaths.Add}>
      {t('common.add')}
    </Button>
  )
}
